module.exports = __webpack_public_path__ + "static/media/Elephant.be7d3d05.ogg";